<!--スケジュール-->
<!--tab2配置表示-->
<template>
  <div style="border: 0px solid red; height:100%" class="i0017Class">
    <!-- 年月 -->
    <el-row type="flex" align="bottom">
      <el-col :span="9" align="middle">
        <span>{{selectedMonthStr}}</span>
      </el-col>
      <el-col :span="14" align="right" style="font-size: 0">
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="preMonthClick">{{$t('MODULE.S0001_LBL_PREMONTH')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="todayClick">{{$t('MODULE.S0001_LBL_TODAY')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="nextMonthClick">{{$t('MODULE.S0001_LBL_NEXTMONTH')}}</el-button>
      </el-col>
    </el-row>
    <el-row class="calenderMode1-calendar" style="text-align:center;margin-top: 8px;">
      <div style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <el-calendar :firstDayOfWeek="7" ref="elCalendar">
          <template slot="dateCell" slot-scope="{date, data}">
            <div slot="reference" class="el-calendar-day" @click="dateCellClick(data)">
              <div v-html="data.day.split('-')[2]"></div>
              <div v-html="calendarCellcharacters(data)"></div>
            </div>
          </template>
        </el-calendar>
      </div>
    </el-row>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0017"
let url = require('@/../config/sysConfig')
export default {
  // name: "Map",
  data() {
    return {
      calenderDateList: [],//calender1表示用list
      selectedMonth: '',//当前月（字符串格式）
      selectedDay: '',//当前点击的日期（字符串格式）
      login_officeCd: '',//登陆者所属officecd
      login_userCd: '',//登陆者cd
      icon_request: this.$t('MODULE.I0017_LBL_REQUEST'),
      icon_recruit: this.$t('MODULE.I0017_LBL_RECRUIT'),
      icon_over: this.$t('MODULE.I0017_LBL_OVER'),
      weekStr: [],//一周的文言
      //add
      clickDayInfo: []//点击一天的详细list
    };
  },

  mounted() {
    this.query()
  },
  created: function () {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.login_officeCd = userInfo.officeCd
    this.login_userCd = userInfo.userCd
    this.selectedMonth = this.dateFormart(new Date(), 'yyyymm')
  },
  methods: {
    // 検索
    async query() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
      // 検索処理
      await amsApi.i_0017_search(this.selectedMonth, this.login_userCd).then(res => {
        //初始化前清空
        this.calenderDateList = undefined;
        this.calenderDateList = new Array();
        this.selectedDay = ''
        this.clickDayInfo = undefined;
        if (res.code === 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close()
          return
        } else {
          //更新基本list
          this.calenderDateList = JSON.parse(JSON.stringify(res.items.jobIntroInfoList));
        }
        loading.close()
      })
      //カレンダーのセルセット
      let calendarThead = document.querySelector(
        ".i0017Class .el-calendar-table thead"
      );
      calendarThead.childNodes[0].style.color = "red"
      calendarThead.childNodes[6].style.color = "blue"
      this.weekStr[0] = this.$t('MODULE.S0001_LBL_CALENDAR_SUN')
      this.weekStr[1] = this.$t('MODULE.S0001_LBL_CALENDAR_MON')
      this.weekStr[2] = this.$t('MODULE.S0001_LBL_CALENDAR_TUE')
      this.weekStr[3] = this.$t('MODULE.S0001_LBL_CALENDAR_WED')
      this.weekStr[4] = this.$t('MODULE.S0001_LBL_CALENDAR_THU')
      this.weekStr[5] = this.$t('MODULE.S0001_LBL_CALENDAR_FRI')
      this.weekStr[6] = this.$t('MODULE.S0001_LBL_CALENDAR_SAT')
      for (var i = 0; i < 7; i++) {
        calendarThead.childNodes[i].innerHTML = this.weekStr[i]
      }
      let calendarTbody = document.querySelector(
        ".i0017Class .el-calendar-table tbody"
      );
      var calendarTbodyChildren = calendarTbody.children;
      var calendarTbodyChildrenChildren;
      var changeChk = false
      var secondChk = false
      var num = 0;
      for (var i = 0; i < calendarTbodyChildren.length; i++) {
        calendarTbodyChildrenChildren = calendarTbody.children[i].cells
        for (var count = 0; count < calendarTbodyChildrenChildren.length; count++) {
          num++
          var date = calendarTbodyChildrenChildren[count].innerText[0] + calendarTbodyChildrenChildren[count].innerText[1]
          if (date == this.calenderDateList[0].date.substring(8, 10)) {
            changeChk = true
          }
          if (changeChk && !secondChk) {
            this.calenderDateList.forEach((item) => {
              if (date == item.date.substring(8, 10)) {
                if (item.applyStatus == '1') {
                  calendarTbodyChildrenChildren[count].style.background = "#DFEDF2"
                } else if (item.applyStatus == '2') {
                  calendarTbodyChildrenChildren[count].style.background = "#F7FBFC"
                } else if (item.applyStatus == '3' || item.applyStatus == '4') {
                  calendarTbodyChildrenChildren[count].style.background = "#DCDCDC"
                }
              }
            })
          } else {
            calendarTbodyChildrenChildren[count].style.background = "#FFFFFF"
          }
          if (num > this.calenderDateList.length && date == this.calenderDateList[this.calenderDateList.length - 1].date.substring(8, 10)) {
            changeChk = false
            secondChk = true
          }
        }
      }
    },
    //日期转为字符串formartType='yyyymm'或'yyyymmdd'，
    dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? ('0' + M) : M) + '-' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? ('0' + M) : M) + '/' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? ('0' + M) : M);

    },
    //前月翌月今日综合处理
    monthChange(val) {
      var getEl = this.$refs.elCalendar.$children[0].$children[val]
      //触发调转事件
      getEl.$el.click();
      this.$nextTick(() => {
        let calendarTitle = document.querySelector(
          ".i0017Class .el-calendar__header .el-calendar__title"
        );
        var monthStr = calendarTitle.innerHTML
        if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
          this.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16)
        } else {
          this.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15)
        }
        //刷新数据
        this.query()
        if (document.querySelector(".is-selected") !== null) {
          document.querySelector(".is-selected").classList.remove('is-selected');
        }

      })
    },
    //前月
    preMonthClick() {
      this.monthChange(0)
    },
    //今日
    todayClick() {
      this.monthChange(1)
    },
    //翌月
    nextMonthClick() {
      this.monthChange(2)
    },
    //日期单元格点击事件。  参数空的场合，直接使用this.selectedDay
    dateCellClick(date) {
      var in_dateDay = date.day
      var statusChk = ''
      if (in_dateDay !== '') {
        this.selectedDay = in_dateDay.replace(/-/g, '/')
      }
      this.calenderDateList.forEach((item) => {
        if (item.date == this.selectedDay) {
          statusChk = item.applyStatus
        }
      })
      if (statusChk == '3' || statusChk == '4') {
        return
      }
      this.$router.push({ path: url.routerUrl_I0018, query: { jobDate: this.selectedDay } })
    },
    //单元格内容表示
    calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/')
      var ret = ''
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(item => item.date === thisDay)
      if (Index !== -1) {
        var applyStatus = this.calenderDateList[Index].applyStatus
        if (applyStatus === '1') {
          ret = this.icon_request
        } else if (applyStatus === '2') {
          ret = this.icon_recruit
        } else if (applyStatus === '3') {
          ret = this.icon_over
        } else if (applyStatus === '4') {
          ret = ''
        }
      } else {
        ret = ''
      }
      return ret
    },
    //cal2的cell样式
    HeaderClass({ row, rowIndex }) {
      return 'HeaderClass'
    },
    //cal2的head样式
    IsCellClass({ row, rowIndex }) {
      return 'IsCellClass'
    },
  },
  computed: {
    //selectedMonth->selectedMonthStr yyyymm->yyyy年mm月
    selectedMonthStr() {
      return this.selectedMonth.substring(0, 4) + '年' + this.selectedMonth.substring(4, 7) + '月'
    }
  },
};
</script>
<style>
.i0017Class * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.i0017Class .is-selected {
  color: #000000;
  font-weight: bold;
}
.i0017Class .el-calendar-table .el-calendar-day {
  height: 50px;
  padding: 0px;
}
.i0017Class .el-calendar__body {
  padding-bottom: 10px;
  padding: 0 0 0 0;
}
/* 本月以外の日付はクリック無効 */
.i0017Class .el-calendar-table td.next {
  pointer-events: none;
}
.i0017Class .el-calendar-table td.prev {
  pointer-events: none;
}
/* copy paste 禁止 */
.i0017Class .calenderMode1-calendar * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.i0017Class .el-main {
  height: 100%;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}

.i0017Class .el-calendar-table thead th {
  background-color: #3f50ec27;
  border: 1px solid #e2e3e4;
  padding-top: 7px;
  padding-bottom: 7px;
}
/*input输入框*/
.i0017Class .card-css-input {
  width: 100%;
  padding: 0px 0px 0px 0px;
}
/* 隐藏calendar的日期头和按钮部分 */
.i0017Class .el-calendar .el-calendar__header {
  display: none;
}
/* radio间距 */
.i0017Class .el-radio {
  margin-right: 5px;
}
.i0017Class .calenderMode2-calendar .cell {
  padding-left: 4px;
  padding-right: 4px;
}
.i0017Class .calenderMode2-calendar .el-input__inner {
  padding-left: 7px;
  padding-right: 4px;
}
.i0017Class .calenderMode2-calendar .el-table td,
.el-table th {
  text-align: center;
}

.i0017Class .opacity {
  position: absolute;
  width: 100px;
  -khtml-opacity: 0.2;
  -moz-opacity: 0.2;
  filter: alpha(opacity=20);
  filter: 'alpha(opacity=20)';
  opacity: 0.2;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=20);
  z-index: 200; /*兼容ie8及以下*/
}

/* 使用换行符可以换行 */
/* .i0017Class .el-table .cell {
  white-space: pre-line;
} */
/* 文字溢出省略号 */
/* .i0017Class .el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
} */
.i0017Class .HeaderClass .cell {
  white-space: pre-line;
}
.i0017Class .IsCellClass .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.i0017Class table.detailTable {
  width: 100%;
  border: 2px solid #444;
  border-spacing: 0;
}
.i0017Class table.detailTable tr,
.i0017Class table.detailTable th {
  border-bottom: 1px solid #444;
}
.i0017Class table.detailTable td,
.i0017Class table.detailTable th {
  border-right: 1px solid #444;
  border-bottom: 1px solid #444;
  padding: 5px;
}
.i0017Class table.detailTable tr td:last-child {
  border-right: 0;
}
.i0017Class table.detailTable tr:last-child td {
  border-bottom: 0;
}
.i0017Class .el-table th {
  background-color: #23b2e8;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0017.vue